const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.769,
    height: 33,
    viewBox: "0 0 7.769 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 164990",
    transform: "rotate(180 7.572 9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 400",
    transform: "translate(11.26 -12.5)",
    style: {
      stroke: "currentColor",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    d: "M0 30V0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 9565",
    cx: 2.885,
    cy: 2.885,
    r: 2.885,
    transform: "translate(8.375 8.558)",
    style: {
      fill: "#fff",
      strokeWidth: 2,
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 9566",
    cx: 2.885,
    cy: 2.885,
    r: 2.885,
    transform: "translate(8.375 -.673)",
    style: {
      fill: "#fff",
      strokeWidth: 2,
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 9567",
    cx: 2.885,
    cy: 2.885,
    r: 2.885,
    transform: "translate(8.375 -9.904)",
    style: {
      fill: "#fff",
      strokeWidth: 2,
      stroke: "currentColor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/Timeline.69799d18e8cc4c6bccf2b1e25b32458a.svg";
export { ForwardRef as ReactComponent };